<template>
  <f7-page no-toolbar no-swipeback login-screen>

    <!-- Top Navbar -->
    <f7-navbar :sliding="false" theme-dark>
      <f7-nav-right>
        <img src="static/logo_frekr.png" style="height: 1.8em;" />
        <f7-link icon-material="sync" href="/" style="visibility: hidden; width: 0px;" />
      </f7-nav-right>
    </f7-navbar>

    <f7-login-screen-title>{{ 'title:initialize_app'|trans }}</f7-login-screen-title>
    <f7-block class="onboarding-copy"><p>{{ trans('info:personal') }}</p><p>{{ trans('info:code_source') }}</p></f7-block>
    <f7-list form>
      <f7-list-input
        type="text"
        autocomplete="off"
        autocapitalize="none"
        :spellcheck="false"
        input-style="font-family: monospace;"
        :label="'label:init_code'|trans"
        :value="pass"
        maxlength="14"
        :placeholder="trans('placeholder:init_code')"
        @input="passChanged($event.target.value)" />
    </f7-list>
    <f7-list>
      <f7-list-button :disabled="initializing" @click="initialize()">{{ 'btn:initialize'|trans }}</f7-list-button>
      <f7-block-footer :inner-html.prop="bb(trans('info:initialize'))" />
    </f7-list>
    <f7-block class="onboarding-copy"><a :href="trans('help:url')" target="_blank" rel="noopener" class="external">{{ trans('help:title') }}</a></f7-block>
  </f7-page>
</template>
<script>
  import Preferences from '../js/preferences.js';
  import RequestManager from '../js/request-manager.js';

  export default {
    data() {
      return {
        pass: '',
        initializing: false
      };
    },
    methods: {
      passChanged: function(val) {
        if (this.pass.length-1 === val.length) {
          this.pass = val;
          return;
        }
        val = val.replace(/\s/g, '').toLowerCase();
        var newVal = '';
        for (var i = 0; i < val.length; ++i) {
          newVal += val[i];
          if (i === 3 || i === 7) newVal += ' ';
        }
        if (this.pass !== newVal) this.pass = newVal;
      },
      initialize: function() {
        if (this.initializing) return;
        var self = this;
        if (!/^[a-z0-9]{4} ?[a-z0-9]{4} ?[a-z0-9]{4}$/.test(this.pass.trim())) {
          this.$f7.dialog.alert(this.pass+': '+this.trans('err:not_an_init_code'));
          return;
        }
        this.initializing = true;
        this.$f7.dialog.preloader();
        RequestManager.setup({pass: this.pass.replace(/ /g,'')}, function(xhr) {
          this.$f7.dialog.close();
          this.initializing = false;
          this.$f7router.navigate('/');
        }.bind(self), function(xhr) {
          this.$f7.dialog.close();
          this.initializing = false;
          this.$f7.dialog.alert(this.trans(xhr.status >= 400 && xhr.status < 500 ? 'err:init' : 'err:sync:'+((xhr.status/100)|0)));
        }.bind(self));
      }
    }
  }
</script>
